import { useMemo } from 'react'
import {
  getBaseGrid,
  getFieldsFromProject,
  getFieldsTree,
  sortBySortOrder,
} from '@/utils/field'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'
import { useGetProjectGridFields } from '@/service-library/hooks/project-grid-fields'

export default function useProjectFieldInfos() {
  const { project } = useProjectContext()

  const allFields = getFieldsFromProject(project)

  // making a call to project grids, so that we don't have to refetch project when we only
  // need to refetch project grid fields
  const { projectGridFields } = useGetProjectGridFields({
    filters: {
      limit: '1000',
      project_id: project.id,
      fields__include:
        'project_grid_field_rules,project_grid_field_type,full_name',
      project_grid_field_rules__fields__include: 'rule',
    },
    initialListData: allFields,
    staleTime: 1000,
  })
  const baseGrid = getBaseGrid(project.project_grids || [])

  const baseFields = sortBySortOrder(
    projectGridFields.filter(
      ({ project_grid_id }) => project_grid_id === baseGrid?.id,
    ),
  )

  const fieldInfos = useMemo(
    () => getFieldsTree(baseFields, projectGridFields),
    [baseFields, projectGridFields],
  )

  return { fieldInfos, allFields: projectGridFields }
}
